export const guideUrl =
  'https://cdn.prod.website-files.com/6044f1e731fd086115d71bf9/674ef0fb90ff21019d929dfa_a748a09bff1ca9ccc5aa1a73b871b79f_Gui%CC%81a%20Payflow%20__%20Factorial%20%282%29.pdf';
